import { useCallback, useContext, useRef } from "react";

import { TourTargetsContext } from "./TourTargetsContext";

export function useTourTargets() {
  const context = useContext(TourTargetsContext);
  if (!context) throw new Error("useTourTargets must be used within TourTargetsProvider");
  return context;
}

export function useTourTarget<T extends HTMLElement>(name: string, enabled = true) {
  const { register, unregister } = useTourTargets();
  const current = useRef<T | null>(null);

  return useCallback(
    (element: T | null) => {
      if (current.current) unregister(name, current.current);
      current.current = element;
      if (element && enabled) register(name, element);
    },
    [name, enabled, register, unregister],
  );
}
